import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section id="about" className="py-28 glow-about">
      <motion.div
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        className="container mx-auto px-6 max-w-6xl"
      >
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <motion.div variants={itemVariants} className="md:col-span-4">
            <h2 className="text-5xl md:text-6xl font-bold font-poppins tracking-tight text-white">
              About <span className="gradient-text">Me</span>
            </h2>
            <div className="w-24 h-px bg-gradient-to-r from-primary-400 to-transparent mt-8" />
          </motion.div>

          <motion.div variants={itemVariants} className="md:col-span-8 md:pt-3">
            <p className="text-xl md:text-2xl font-light text-gray-300 leading-relaxed">
              I'm a Computer Science Engineering student at R.V. College of Engineering, Bangalore,
              focused on Machine Learning, AI, and Full Stack Development. My work spans building
              web applications, experimenting with AI-driven systems, and exploring how software
              can be used to solve practical, real-world problems.
            </p>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default About;
